import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { IPreferenceVenue } from './venue.types';

@Timestampable
@Untrackable
export class PreferenceVenue extends AbstractDocument<IPreferenceVenue> {
  readonly collections = {};
}
